import * as React from 'react';

import { Button } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useRouteError } from 'react-router-dom';

import { AntdRouterLink, PrimitiveResult } from 'components';
import { PATHNAME } from 'utils';

const {
  LOCAL: {
    HOME: { BASE_URL: HOME_BASE_URL },
  },
} = PATHNAME;

export default function RouteError() {
  const error = useRouteError() as any;

  const { data, status = '404' } = error ?? {};
  const title = data || 'صفحه مورد نظر یافت نشد.';
  const subTitle =
    'متأسفیم، صفحه‌ای با این آدرس در دسترس نیست یا ممکن است حذف شده باشد.';

  return (
    <React.Fragment>
      <Helmet>
        <title>{`صفحه ${status} | کاشی لند`}</title>
      </Helmet>
      <PrimitiveResult
        status={status}
        title={title}
        subTitle={subTitle}
        extra={
          <Button type='primary'>
            <AntdRouterLink to={HOME_BASE_URL} className='hover:text-inherit'>
              بازگشت به خانه
            </AntdRouterLink>
          </Button>
        }
      />
    </React.Fragment>
  );
}
